"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isFieldRequired(fieldName, schema) {
    if (!schema || typeof schema.describe !== 'function')
        return false;
    // Resolve schema if needed
    var validationSchema = typeof schema._resolve === 'function' ? schema._resolve() : schema;
    // Check if `describe` still exists after resolving
    if (typeof validationSchema.describe !== 'function')
        return false;
    var describedValidationSchema = validationSchema.describe();
    // Defensive check in case `fields` is missing or malformed
    if (!describedValidationSchema.fields || !describedValidationSchema.fields[fieldName]) {
        return false;
    }
    var fieldDescription = describedValidationSchema.fields[fieldName];
    return fieldDescription.tests.some(function (test) { return test.name === 'required'; });
}
exports.default = isFieldRequired;
